<template>
  <div class="tab-pane">
    <div class="pane-item">
      <div class="pane-item-text">
        <div class="pane-item-title">一种基于区块链的零信任网络访问系统与2022年6月27日取得发明专利证书</div>
        <div class="pane-item-desc" style="margin-bottom: 58px">
          &emsp;&emsp;零信任网络访问（Zero Trust Network Access，简称
          ZTNA）是一种产品和服务，这些产品和服务创建了一个基于身份和上下文的逻辑访问边界，该边界围住了一个用户和一个应用程序或一组应用程序。<br />
          &emsp;&emsp;ZTNA 的访问策略主要基于用户、设备、应用程序身份。实现只允许访问特定的应用程序，而非底层网络。相对于 VPN、DMZ 这类传统手段而言，ZTNA
          限制了用户对所有端口和协议或所有应用程序的过度访问。<br />
        </div>
      </div>
      <img src="@/assets/about/zl1.png" />
    </div>
  </div>
</template>
<script>
export default {
  name: "copyright-software",

  data() {
    return {};
  },
  created() {},
  computed: {},

  mounted() {},

  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    choose(index) {
      this.chooseIndex = index;
    },
  },
};
</script>
<style lang="less" scoped src="./copyright.less">
</style>